import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import {
  AddImeiDetailsApi,
  baseurl,
  GetImeiDetailsApi,
  getProfileApi,
  GetSubUserProfileApi,
  SetLimitCheckApi,
  uploadImageApi,
} from "../Utility/Api";

import AddCustomerModel from "./AddCustomerModel";
import NewRepair from "./NewRepair";
import DemoToggle from "./DemoToggle";
import LoadingBoxes from "./LoadingBoxes";

// const arrows = ["→", "→", "↱", "↓", "↰", "↓", "→", "→", "→"];
const arrows = [".", ".", ".", ".", ".", ".", ".", ".", "."];

const CreateTicket = (props) => {
  const [filteredData, setFilteredData] = useState([]);
  const [searchTermCustomer, setsearchTermCustomer] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [allCustomer, setAllCustomer] = useState([]);
  const [loading1, setLoading1] = useState(false);
  const [showListCustomer, setShowListCustomer] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedCustomerPhone, setSelectedCustomerPhone] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [error, setError] = useState({});
  const [typedText, setTypedText] = useState("");
  const dropdownRef1 = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const fileInputRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const dropdownRef4 = useRef(null);
  const dropdownRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const dropdownRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const dropdownRef5 = useRef(null);
  const [showListService, setShowListService] = useState(false);
  const [searchTermService, setSearchTermService] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [selectedServiceId, setSelectedServiceId] = useState("");
  const [AllBin, setAllBin] = useState([]);
  const [showListRepair, setShowListRepair] = useState(false);
  const [searchTermRepair, setSearchTermRepair] = useState("");
  const [selectedRepair, setSelectedRepair] = useState("");
  const [selectedRepairId, setSelectedRepairId] = useState("");
  const [AllRepair, setAllRepair] = useState([]);
  const [showListWarranty, setShowListWarranty] = useState(false);
  const [searchTermWarranty, setSearchTermWarranty] = useState("");
  const [selectedWarranty, setSelectedWarranty] = useState("");
  const [selectedWarrantyId, setSelectedWarrantyId] = useState("");
  const [AllWarranty, setAllWarranty] = useState([]);

  const [showListAssigned, setShowListAssigned] = useState(false);
  const [searchTermAssigned, setSearchTermAssigned] = useState("");
  const [selectedAssigned, setSelectedAssigned] = useState("");
  const [selectedAssignedId, setSelectedAssignedId] = useState("");
  const [AllAssigned, setAllAssigned] = useState([]);
  const [dueDate, setDueDate] = useState(null);
  const [password, setPassword] = useState("");
  const [description, setDescription] = useState("");
  const [driverLiecense, setDriverLiecense] = useState("");
  const [imeiNumber, setIMEINumber] = useState("");
  const [images, setImages] = useState("");
  const [imageMsg, setImageMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);
  const [techPerson, setTechPerson] = useState([]);
  const [step, setStep] = useState(1);

  const checklistOptions = ["Case", "Charger", "Memory Card"];

  const handleCheckboxChange2 = (item) => {
    setSelectedItems(
      (prevSelected) =>
        prevSelected.includes(item)
          ? prevSelected.filter((i) => i !== item) // remove if already selected
          : [...prevSelected, item] // add if not selected
    );
  };

  const handleNext = () => {
    setStep(2); // Show SelectDeviceModal content
  };

  const handleBack = () => {
    setStep(1); // Go back to CreateTicket
  };

  const handleCloseAll = () => {
    props?.onpress(); // Close parent modal
    setStep(1); // Reset step
  };

  const filteredRepair = AllRepair.filter((brand) => {
    const name = brand.name;
    if (name && typeof name === "string") {
      return name.toLowerCase().includes(searchTermService.toLowerCase());
    }

    return false;
  });
  const filteredWarranty = AllWarranty.filter((brand) => {
    const name = brand.name;
    if (name && typeof name === "string") {
      return name.toLowerCase().includes(searchTermService.toLowerCase());
    }

    return false;
  });

  const handleSearchChangeService = (e) => {
    setSearchTermService(e.target.value);
    setTypedText(e.target.value);
    setSelectedService(null);
  };
  const handleSearchChangeAssigned = (e) => {
    setSearchTermAssigned(e.target.value);
    setTypedText(e.target.value);
    setSelectedAssigned(null);
  };

  const handleSearchChangeRepair = (e) => {
    setSearchTermRepair(e.target.value);
    setTypedText(e.target.value);
    setSelectedRepair(null);
  };
  const handleSearchChangeWarranty = (e) => {
    setSearchTermWarranty(e.target.value);
    setTypedText(e.target.value);
    setSelectedWarranty(null);
  };

  const togglePasswordVisibility = (e) => {
    e.preventDefault();
    setShowPassword((prev) => !prev);
  };

  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop ===
      document.documentElement.offsetHeight
    ) {
      if (hasMore && !loading1) {
        setPage((prevPage) => prevPage + 1);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, loading1]);

  useEffect(() => {
    setAllCustomer([]);
    setFilteredData([]);
    setPage(1);
    GetCustomer(1, searchTermCustomer);
  }, [searchTermCustomer]);

  useEffect(() => {
    if (page > 1) {
      GetCustomer(page, searchTermCustomer);
    }
  }, [page]);

  useEffect(() => {
    GetBinLoc();
    GetRepairTask();
    GetWarranty();
  }, []);

  const GetCustomer = (page, searchTerm) => {
    let local = localStorage.getItem("token");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${local}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${baseurl}getAllCustomer?pageSize=10&page=${page}&keyword=${searchTerm}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result.status === true) {
          setFilteredData((prevData) => {
            const combinedData = Array.isArray(prevData)
              ? [...prevData, ...result?.data]
              : result?.data;

            const uniqueData = Array.from(
              new Set(combinedData.map((item) => item.id))
            ).map((id) => combinedData.find((item) => item.id === id));

            return uniqueData;
          });

          setAllCustomer((prevData) =>
            Array.isArray(prevData)
              ? [...prevData, ...result.data]
              : result.data
          );

          setHasMore(result?.data?.length > 0);
        } else {
          setHasMore(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const filteredCustomer = filteredData.filter((customer) => {
    const firstName = customer?.firstName?.toLowerCase();
    const lastName = customer?.lastName?.toLowerCase();
    const phoneNumber = customer?.phoneNumber?.toLowerCase();
    const searchTerm = searchTermCustomer.toLowerCase();

    // Check if any of the fields contain the search term
    return (
      (firstName && firstName.includes(searchTerm)) ||
      (lastName && lastName.includes(searchTerm)) ||
      (phoneNumber && phoneNumber.includes(searchTerm))
    );
  });
  const handleCustomerSelect = (brand) => {
    setSelectedCustomer(brand.firstName);
    setSelectedCustomerId(brand.id);
    setShowListCustomer(false);
    const phone = brand?.phoneNumber;
    const nameWithPhone = phone
      ? `${brand.firstName} (${phone})`
      : brand.firstName;
    setInputValue(nameWithPhone);

    // setInputValue(`${brand.firstName} (${brand?.phoneNumber})`);
    //GetCustomerDevice(brand.id);
    setSelectedCustomerPhone(brand?.phoneNumber);

    if (error.selectedCustomer) {
      setError({ ...error, selectedCustomer: "" });
    }
  };
  const handleSearchChangeCustomer = (e) => {
    setsearchTermCustomer(e.target.value);
    setTypedText(e.target.value);
    setSelectedCustomer(null);
    setShowListCustomer(true);
  };
  const onPress = (data) => {
    console.log("addcustromerr", data);
    setShowModal(false);
    setSelectedCustomer(data?.firstName);
    setSelectedCustomerId(data?.id);
    setShowListCustomer(false);
    const phone = data?.phoneNumber;
    const nameWithPhone = phone
      ? `${data.firstName} (${phone})`
      : data.firstName;
    setInputValue(nameWithPhone);
  };
  const onLoad = () => {
    // console.log("addcustromerr", data);

    setShowModal(false);
    // setSelectedCustomer(data?.firstName);
    // setSelectedCustomerId(data?.id);
    // setShowListCustomer(false);
    // const phone = data?.phoneNumber;
    // const nameWithPhone = phone
    //   ? `${data.firstName} (${phone})`
    //   : data.firstName;
    // setInputValue(nameWithPhone);
  };
  const onpress = () => {
    setShowModal1(false);
  };

  const [selected, setSelected] = useState([]);
  const [disabled, setDisabled] = useState(false);

  const handleDotClick = (index) => {
    if (!selected.includes(index) && !disabled) {
      setSelected([...selected, index]);
    }
  };
  const [patteren, setPatteren] = useState([]);
  const handleSave = () => {
    // console.log("Pattern to save:", selected);
    setPatteren(selected);
    // Call your API here
    // await api.savePattern({ pattern: selected })
    alert("Pattern saved!");
    setDisabled(true);
  };

  const handleReset = () => {
    setSelected([]);
    setDisabled(false);
  };

  // useEffect(() => {
  //   if (savedPattern?.length > 0) {
  //     setSelected(savedPattern);
  //     setDisabled(true);
  //   }
  // }, [savedPattern]);

  const handlePreRepairImageUpload = (e) => {
    handleImages(e); // Call your existing image handling logic
  };
  const handleImages = (e) => {
    var file = e.target.files[0];

    if (file) {
      const minSizeInBytes = 5000; // 5 KB
      const maxSizeInBytes = 1024 * 1024; // 1 MB

      if (file.size < minSizeInBytes) {
        // setImageMsg("Image size is below the minimum allowed size (5 KB)");
        //Swal.fire("Image size is below the minimum allowed size (5 KB");
        Swal.fire({
          title: "Image size is below the minimum allowed size (5 KB)",
          customClass: {
            container: "custom-swal-container",

            confirmButton: "custom-swal-confirm-button",
          },
        });
        e.target.value = null;
        setTimeout(() => {
          setImageMsg("");
        }, 2000);
        return;
      }

      // Check if the file name contains only one dot before the extension
      const fileName = file.name;
      const lastDotIndex = fileName.lastIndexOf(".");
      const baseName = fileName.substring(0, lastDotIndex);
      const extension = fileName.substring(lastDotIndex + 1);

      // Only allow files with a single dot in the base name
      if (baseName.includes(".")) {
        setImageMsg(
          "File name is not valid. Only one dot is allowed before the extension."
        );
        Swal.fire({
          title:
            "File name is not valid. Only one dot is allowed before the extension.",
          customClass: {
            container: "custom-swal-container",

            confirmButton: "custom-swal-confirm-button",
          },
        });
        e.target.value = null;
        setTimeout(() => {
          setImageMsg("");
        }, 2000);

        return;
      }

      let size = file.type.replace("/", ".");
      var blob = file.slice(0, file.size, file.type);
      const newName = new Date().getTime() + size;
      var newFile = new File([blob], newName, { type: file.type });

      UploadImage(newFile);
    }
  };

  const UploadImage = async (newFile) => {
    setLoading(true);
    var formdata = new FormData();
    formdata.append("file", newFile);
    formdata.append("type", "ticket-images");

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    //console.log("imaggegg", newFile);
    fetch(uploadImageApi, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setImages(result?.data);

        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };

  const AddBin = () => {
    const token = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const raw = JSON.stringify({
      name: typedText,
      description: "",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${baseurl}addBinLocation`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result?.status === true) {
          GetBinLoc();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const GetBinLoc = () => {
    const token = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${baseurl}getBinLocations`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result?.status === true) {
          setAllBin(result?.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const AddRepairTask = () => {
    const token = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const raw = JSON.stringify({
      name: typedText,
      description: "",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${baseurl}addRepairTaskType`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //console.log(result);
        if (result?.status === true) {
          GetRepairTask();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const GetRepairTask = () => {
    const token = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${baseurl}getRepairTaskTypes`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //console.log(result);
        if (result?.status === true) {
          setAllRepair(result?.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const AddWarranty = () => {
    const token = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const raw = JSON.stringify({
      name: typedText,
      description: "",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${baseurl}addWarrantyApplicable`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //console.log(result);
        if (result?.status === true) {
          GetWarranty();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const GetWarranty = () => {
    const token = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${baseurl}getWarrantyApplicable`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result?.status === true) {
          setAllWarranty(result?.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleButtonClickService = (e) => {
    e.preventDefault();
    setShowListService(!showListService);
  };
  const handleButtonClickAssigned = (e) => {
    e.preventDefault();
    setShowListAssigned(!showListAssigned);
  };

  const handleButtonClickRepair = (e) => {
    e.preventDefault();
    setShowListRepair(!showListRepair);
  };
  const handleButtonClickWarranty = (e) => {
    e.preventDefault();
    setShowListWarranty(!showListWarranty);
  };
  const handleServiceSelect = (brand) => {
    setSelectedService(brand.name);
    setSelectedServiceId(brand.id);
    setShowListService(false);
    if (error.selectedService) {
      setError({ ...error, selectedService: "" });
    }
  };
  const handleAssignedSelect = (brand) => {
    setSelectedAssigned(brand);
    // setSelectedAssignedId(brand.id);
    setShowListAssigned(false);
    // if (error.selectedService) {
    //   setError({ ...error, selectedService: "" });
    // }
  };

  const handleRepairSelect = (brand) => {
    setSelectedRepair(brand.name);
    setSelectedRepairId(brand.id);
    setShowListRepair(false);
    if (error.selectedRepair) {
      setError({ ...error, selectedRepair: "" });
    }
  };

  const handleWarrantySelect = (brand) => {
    setSelectedWarranty(brand.name);
    setSelectedWarrantyId(brand.id);
    setShowListWarranty(false);
    if (error.selectedWarranty) {
      setError({ ...error, selectedWarranty: "" });
    }
  };

  const handleAddNewClickService = (e) => {
    if (!typedText.trim()) {
      Swal.fire({
        title: "Please enter a valid Service name!",
        customClass: {
          container: "custom-swal-container",

          confirmButton: "custom-swal-confirm-button",
        },
      });
      return;
    }
    setSelectedService(typedText);
    setShowListService(false);
    setSearchTermService("");
    setTypedText("");
    AddBin();
  };

  const handleAddNewClickRepair = (e) => {
    if (!typedText.trim()) {
      Swal.fire({
        title: "Please enter a valid Service name!",
        customClass: {
          container: "custom-swal-container",

          confirmButton: "custom-swal-confirm-button",
        },
      });
      return;
    }
    setSelectedRepair(typedText);
    setShowListRepair(false);
    setSearchTermRepair("");
    setTypedText("");
    AddRepairTask();
  };
  const handleAddNewClickWarranty = (e) => {
    if (!typedText.trim()) {
      Swal.fire({
        title: "Please enter a valid Service name!",
        customClass: {
          container: "custom-swal-container",

          confirmButton: "custom-swal-confirm-button",
        },
      });
      return;
    }
    setSelectedWarranty(typedText);
    setShowListWarranty(false);
    setSearchTermWarranty("");
    setTypedText("");
    AddWarranty();
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setShowListService(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef2]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef3.current &&
        !dropdownRef3.current.contains(event.target)
      ) {
        setShowListRepair(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef3]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef4.current &&
        !dropdownRef4.current.contains(event.target)
      ) {
        setShowListWarranty(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef4]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef5.current &&
        !dropdownRef5.current.contains(event.target)
      ) {
        setShowListAssigned(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef5]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
        setShowListCustomer(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef1]);

  const checklistKeys = [
    "PowersOn",
    "FaceID",
    "TouchFunctionality",
    "FingerprintScanner",
    "SDCardinstalled",
    "SimCardInstalled",
    "Camera(Front)",
    "Camera(Rear)",
    "Speaker(Loudspeaker)",
    "Speaker(Earpeice)",
    "Microphone",
    "Volume",
    "PowerButton",
    "VolumeButtons",
    "SilentSwitch",
    "MuteButton",
    "NetworkSignal",
    "Wifi/Bluetooth",
  ];

  const checklistLabels = [
    "Powers on",
    "Face ID",
    "Touch functionality",
    "Fingerprint Scanner",
    "SD Card installed",
    "Sim Card Installed",
    "Camera (Front)",
    "Camera (Rear)",
    "Speaker (Loudspeaker)",
    "Speaker (Earpeice)",
    "Microphone",
    "Volume",
    "Power Button",
    "Volume Buttons",
    "Silent Switch",
    "Mute button",
    "Network Signal",
    "Wifi/Bluetooth",
  ];

  const [checklistStates, setChecklistStates] = useState(() => {
    const initial = {};
    checklistKeys.forEach((key) => {
      initial[key] = "center"; // default state
    });
    return initial;
  });

  const handleToggleChange = (key, newState) => {
    setChecklistStates((prev) => ({
      ...prev,
      [key]: newState,
    }));
  };
  const filteredService = AllBin.filter((brand) => {
    const name = brand.name;
    if (name && typeof name === "string") {
      return name.toLowerCase().includes(searchTermService.toLowerCase());
    }

    return false;
  });

  const [selectAllState, setSelectAllState] = useState("center");
  const handleSelectAllChange = (side) => {
    setSelectAllState(side);
    const updated = {};
    checklistKeys.forEach((key) => {
      updated[key] = side;
    });
    setChecklistStates(updated);
  };
  const getFormattedChecklistForAPI = () => {
    const result = {};
    checklistKeys.forEach((key) => {
      const state = checklistStates[key];
      // left = false, right = true, center = skip (or can default to false)
      if (state === "left") {
        result[key] = false;
      } else if (state === "right") {
        result[key] = true;
      }
      // If 'center', we skip it or you can decide to set it as false
    });
    return result;
  };

  const [CheckListValues, setCheckListValues] = useState();
  const [checkboxOption, setCheckBoxOption] = useState();

  const handleSave2 = () => {
    const formattedChecklist = getFormattedChecklistForAPI();

    // console.log("Checklist to send in API:", formattedChecklist);
    setCheckListValues(formattedChecklist);

    // Example structure to pass in API:
    const apiPayload = {
      preRepairChecklist: formattedChecklist,
      // any other data you need...
    };

    const checklistData = {};

    checklistOptions.forEach((item) => {
      checklistData[item] = selectedItems.includes(item);
    });

    const apiData = {
      ...checklistData,
      // any other fields here...
    };
    setCheckBoxOption(apiData);

    // Call your API here with `apiPayload`

    setShowModal2(false);
  };

  return (
    <>
      {loading ? (
        <>
          <div className="loading-box">
            <LoadingBoxes />
          </div>
        </>
      ) : // <div className="landing_loader">
      //   <div className="innerloader">
      //     <img src="img/spin-1s-156px.gif" alt="" />
      //   </div>
      // </div>
      null}
      {step === 1 ? (
        <>
          <div
            className="modal-dialog modal-dialog-centered cusmodal_xl"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="createnewserviceModalLabel">
                  New Service
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setShowModal2(false);

                    document
                      .querySelectorAll(".modal-backdrop")
                      .forEach((el) => el.classList.remove("modal-backdrop"));
                  }}
                >
                  <span className="close_icon" />
                </button>
                <p>Create a new service and confirm customer information</p>
              </div>
              {/* <DemoToggle /> */}
              <div className="modal-body">
                <div className="custom_form repairservice_form">
                  <form
                    action=""
                    method=""
                    className="cus_form"
                    data-gtm-form-interact-id={0}
                  >
                    <div className="repair_service_left">
                      <div className="form_row">
                        <div className="form_column col_full">
                          <div className="form-group">
                            <label className="cus_label">
                              Customer Name<span>*</span>
                            </label>
                            <div
                              className="formfield add_cust_field selectcustomerboxcustmlist"
                              ref={dropdownRef1}
                            >
                              <div className="tagsscustomdiv">
                                <div>
                                  <input
                                    type="text"
                                    className="form-control customsearchinputboxsetting"
                                    name="firstName"
                                    placeholder="Enter Customer Name"
                                    data-gtm-form-interact-field-id={0}
                                    value={inputValue}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setInputValue(value);

                                      if (value === "") {
                                        setSelectedCustomer("");
                                        setSelectedCustomerPhone("");
                                      }

                                      handleSearchChangeCustomer(e);
                                    }}
                                    onClick={() =>
                                      setShowListCustomer(!showListCustomer)
                                    }
                                  />

                                  <a
                                    href="#"
                                    className="newcust_add"
                                    data-toggle="modal"
                                    data-target="#addcustomerModal"
                                    onClick={() => {
                                      setShowModal(true);

                                      setStep(3);
                                    }}
                                  >
                                    New
                                  </a>
                                  <div className="field_icon">
                                    <img
                                      src="assets/img/repair-search-icon.png"
                                      alt=""
                                    />
                                  </div>
                                </div>
                                {showListCustomer && (
                                  <div className="addselectbox">
                                    <ul>
                                      {filteredCustomer.map((brand, index) => (
                                        <li
                                          key={index}
                                          onClick={() =>
                                            handleCustomerSelect(brand)
                                          }
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          {brand?.firstName}
                                          {"  "}
                                          {brand?.lastName}{" "}
                                          {brand?.phoneNumber
                                            ? `(${brand.phoneNumber})`
                                            : ""}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                            {error.selectedCustomer && (
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "red",
                                }}
                              >
                                {error.selectedCustomer}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="form_column col_full cus_searchdropdown">
                          <div className="form-group">
                            <label className="cus_label">Assigned To</label>
                            <div
                              className="formfield selectcustomerboxcustmlist"
                              ref={dropdownRef5}
                            >
                              <div
                                class="form-control"
                                bis_skin_checked="1"
                                onClick={() =>
                                  setShowListAssigned(!showListAssigned)
                                }
                              >
                                {selectedAssigned ||
                                  props?.profile ||
                                  "Select Assigned To"}
                                <button
                                  style={{ cursor: "pointer" }}
                                  onClick={handleButtonClickAssigned}
                                  className="field_arrow"
                                >
                                  <img
                                    src="assets/img/select-arrow.webp"
                                    alt="Handy Icon"
                                  />
                                </button>
                                <div className="field_icon">
                                  <img
                                    src="assets/img/repair-location-icon.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              {showListAssigned && (
                                <>
                                  <div
                                    className="tagsscustomdiv"
                                    // style={{ position: "relative" }}
                                  >
                                    {/* <input
                                ref={inputRef4}
                                type="text"
                                className="customsearchinputboxsetting inputdeviceformcustmbox form-control"
                                placeholder="Select Assigned To"
                                // value={searchTermAssigned || selectedAssigned}
                                // onChange={handleSearchChangeAssigned}
                                value={selectedAssigned}
                              /> */}
                                    <div className="addselectbox">
                                      <ul>
                                        {props?.techPerson?.map((brand) => (
                                          <li
                                            key={brand}
                                            onClick={() =>
                                              handleAssignedSelect(brand)
                                            }
                                            style={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            {brand}
                                          </li>
                                        ))}
                                      </ul>
                                      {/* {typedText &&
                                    !filteredService.includes(typedText) && (
                                      <button
                                        onClick={() => {
                                          handleAddNewClickService();
                                          if (inputRef2.current) {
                                            inputRef2.current.focus();
                                          }
                                        }}
                                        style={{ backgroundColor: "#9d3dd3" }}
                                        type="button"
                                        className="btn cus_addnew_btn  customaddnewcatebtnsetting"
                                      >
                                        <span>+</span> Add "{typedText}" as a
                                        new Bin Location
                                      </button>
                                    )} */}
                                    </div>{" "}
                                  </div>{" "}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="form_column col_full">
                          <div className="form-group">
                            <label className="cus_label">
                              Task Due Date &amp; time
                            </label>
                            <div className="formfield">
                              <input
                                type="date"
                                className="form-control"
                                name="duedate"
                                placeholder="03/26/2023"
                                autoComplete="off"
                                value={dueDate}
                                onChange={(e) => setDueDate(e.target.value)}
                              />
                              <div className="field_icon">
                                <img
                                  src="assets/img/repair-calendar-icon.png"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form_column col_full cus_searchdropdown">
                          <div className="form-group">
                            <label className="cus_label">Bin Location</label>
                            <div
                              className="formfield selectcategoryformbox selectcustomerboxcustmlist"
                              ref={dropdownRef2}
                            >
                              <div
                                class="form-control"
                                bis_skin_checked="1"
                                onClick={() =>
                                  setShowListService(!showListService)
                                }
                              >
                                {selectedService || "Bin Location"}
                                <button
                                  style={{ cursor: "pointer" }}
                                  onClick={handleButtonClickService}
                                  className="field_arrow"
                                >
                                  <img
                                    src="assets/img/select-arrow.webp"
                                    alt="Handy Icon"
                                  />
                                </button>
                                <div className="field_icon">
                                  <img
                                    src="assets/img/repair-location-icon.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              {showListService && (
                                <>
                                  <div
                                    className="tagsscustomdiv"
                                    //style={{ position: "relative" }}
                                  >
                                    <input
                                      ref={inputRef2}
                                      type="text"
                                      className="customsearchinputboxsetting tagsinputcstmwit inputdeviceformcustmbox form-control"
                                      placeholder="Enter Bin Location"
                                      value={
                                        searchTermService || selectedService
                                      }
                                      onChange={handleSearchChangeService}
                                    />
                                    <div className="addselectbox">
                                      <ul>
                                        {filteredService.length > 0 ? (
                                          filteredService.map((brand) => (
                                            <li
                                              key={brand.id}
                                              onClick={() =>
                                                handleServiceSelect(brand)
                                              }
                                              style={{
                                                cursor: "pointer",
                                              }}
                                            >
                                              {brand.name}
                                            </li>
                                          ))
                                        ) : (
                                          <div
                                            style={{
                                              padding: "8px",
                                              color: "#999",
                                              textAlign: "center",
                                            }}
                                          >
                                            No results matching "
                                            {searchTermService}"
                                          </div>
                                        )}
                                      </ul>
                                      {typedText &&
                                        !filteredService.includes(
                                          typedText
                                        ) && (
                                          <button
                                            onClick={() => {
                                              handleAddNewClickService();
                                              if (inputRef2.current) {
                                                inputRef2.current.focus();
                                              }
                                            }}
                                            style={{
                                              backgroundColor: "#9d3dd3",
                                            }}
                                            type="button"
                                            className="btn cus_addnew_btn  customaddnewcatebtnsetting"
                                          >
                                            <span>+</span> Add "{typedText}" as
                                            a new Bin Location
                                          </button>
                                        )}
                                    </div>{" "}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="form_column col_full cus_searchdropdown">
                          <div className="form-group">
                            <label className="cus_label">
                              Repair Task Type
                            </label>
                            <div
                              className="formfield selectcustomerboxcustmlist"
                              ref={dropdownRef3}
                            >
                              <div
                                class="form-control"
                                bis_skin_checked="1"
                                onClick={() =>
                                  setShowListRepair(!showListRepair)
                                }
                              >
                                {selectedRepair || "Repair Task Type"}
                                <button
                                  style={{ cursor: "pointer" }}
                                  onClick={handleButtonClickRepair}
                                  className="field_arrow"
                                >
                                  <img
                                    src="assets/img/select-arrow.webp"
                                    alt="Handy Icon"
                                  />
                                </button>
                                <div className="field_icon">
                                  <img
                                    src="assets/img/repair-task-icon.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              {showListRepair && (
                                <>
                                  <div className="tagsscustomdiv">
                                    <input
                                      ref={inputRef3}
                                      type="text"
                                      className="customsearchinputboxsetting inputdeviceformcustmbox form-control"
                                      placeholder="Enter Repair Task Type"
                                      value={searchTermRepair || selectedRepair}
                                      onChange={handleSearchChangeRepair}
                                    />
                                    <div className="addselectbox">
                                      <ul>
                                        {filteredRepair.length > 0 ? (
                                          filteredRepair.map((brand) => (
                                            <li
                                              key={brand.id}
                                              onClick={() =>
                                                handleRepairSelect(brand)
                                              }
                                              style={{
                                                cursor: "pointer",
                                              }}
                                            >
                                              {brand.name}
                                            </li>
                                          ))
                                        ) : (
                                          <div
                                            style={{
                                              padding: "8px",
                                              color: "#999",
                                              textAlign: "center",
                                            }}
                                          >
                                            No results matching "
                                            {searchTermRepair}"
                                          </div>
                                        )}
                                      </ul>
                                      {typedText &&
                                        !filteredRepair.includes(typedText) && (
                                          <button
                                            onClick={() => {
                                              handleAddNewClickRepair();
                                              if (inputRef3.current) {
                                                inputRef3.current.focus();
                                              }
                                            }}
                                            style={{
                                              backgroundColor: "#9d3dd3",
                                            }}
                                            type="button"
                                            className="btn cus_addnew_btn  customaddnewcatebtnsetting"
                                          >
                                            <span>+</span> Add "{typedText}" as
                                            a new Repair Task Type
                                          </button>
                                        )}
                                    </div>{" "}
                                  </div>{" "}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="form_column col_full cus_searchdropdown">
                          <div className="form-group">
                            <label className="cus_label">
                              Warranty Applicable
                            </label>
                            <div
                              className="formfield selectcustomerboxcustmlist"
                              ref={dropdownRef4}
                            >
                              <div
                                class="form-control"
                                bis_skin_checked="1"
                                onClick={() =>
                                  setShowListWarranty(!showListWarranty)
                                }
                              >
                                {selectedWarranty ||
                                  "Select Warranty Applicable"}
                                <button
                                  style={{ cursor: "pointer" }}
                                  onClick={handleButtonClickWarranty}
                                  className="field_arrow"
                                >
                                  <img
                                    src="assets/img/select-arrow.webp"
                                    alt="Handy Icon"
                                  />
                                </button>
                                <div className="field_icon">
                                  <img
                                    src="assets/img/repair-warranty-icon.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              {showListWarranty && (
                                <>
                                  <div className="tagsscustomdiv">
                                    <input
                                      ref={inputRef1}
                                      type="text"
                                      className="customsearchinputboxsetting inputdeviceformcustmbox form-control"
                                      placeholder="Enter Warranty Applicable"
                                      value={
                                        searchTermWarranty || selectedWarranty
                                      }
                                      onChange={handleSearchChangeWarranty}
                                    />
                                    <div className="addselectbox">
                                      <ul>
                                        {filteredWarranty.length > 0 ? (
                                          filteredWarranty.map((brand) => (
                                            <li
                                              key={brand.id}
                                              onClick={() =>
                                                handleWarrantySelect(brand)
                                              }
                                              style={{
                                                cursor: "pointer",
                                              }}
                                            >
                                              {brand.name}
                                            </li>
                                          ))
                                        ) : (
                                          <div
                                            style={{
                                              padding: "8px",
                                              color: "#999",
                                              textAlign: "center",
                                            }}
                                          >
                                            No results matching "
                                            {searchTermWarranty}"
                                          </div>
                                        )}
                                      </ul>
                                      {typedText &&
                                        !filteredWarranty.includes(
                                          typedText
                                        ) && (
                                          <button
                                            onClick={() => {
                                              handleAddNewClickWarranty();
                                              if (inputRef1.current) {
                                                inputRef1.current.focus();
                                              }
                                            }}
                                            style={{
                                              backgroundColor: "#9d3dd3",
                                            }}
                                            type="button"
                                            className="btn cus_addnew_btn  customaddnewcatebtnsetting"
                                          >
                                            <span>+</span> Add "{typedText}" as
                                            a new Warranty Applicable
                                          </button>
                                        )}
                                    </div>{" "}
                                  </div>{" "}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="repair_service_right">
                      <h4>Additional Information</h4>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form_column col_full">
                            <div className="form-group">
                              <label className="cus_label">IMEI / Serial</label>
                              <div className="formfield selectcustomerboxcustmlist">
                                <div
                                  className="tagsscustomdiv"
                                  style={{ position: "relative" }}
                                >
                                  <div>
                                    <input
                                      type="text"
                                      className="customsearchinputboxsetting inputdeviceformcustmbox form-control"
                                      placeholder="Enter IMEI / Serial"
                                      value={imeiNumber}
                                      onChange={(e) =>
                                        setIMEINumber(e.target.value.trim())
                                      }
                                    />
                                    <div className="field_icon">
                                      <img
                                        src="assets/img/repair-imeiserial-icon.png"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="form_column col_full">
                            <div className="form-group">
                              <label className="cus_label">
                                ID / License Number
                              </label>
                              <div className="formfield selectcustomerboxcustmlist">
                                <div
                                  className="tagsscustomdiv"
                                  style={{ position: "relative" }}
                                >
                                  <div>
                                    <input
                                      type="text"
                                      className="customsearchinputboxsetting inputdeviceformcustmbox form-control"
                                      placeholder="Enter ID Number"
                                      value={driverLiecense}
                                      onChange={(e) =>
                                        setDriverLiecense(e.target.value)
                                      }
                                    />
                                    <div className="field_icon">
                                      <img
                                        src="assets/img/repair-license-icon.png"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="passcode_pin_tabs">
                            <ul
                              className="nav nav-pills repair_patteren_pin_tabs"
                              id="repairtab"
                              role="tablist"
                            >
                              <li className="nav-item">
                                <a
                                  className="nav-link active"
                                  id="pattern-tab"
                                  data-toggle="tab"
                                  href="#pattern"
                                  role="tab"
                                  aria-controls="pattern"
                                  aria-selected="true"
                                >
                                  Pattern
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  id="pin-tab"
                                  data-toggle="tab"
                                  href="#pin"
                                  role="tab"
                                  aria-controls="pin"
                                  aria-selected="false"
                                >
                                  Pin
                                </a>
                              </li>
                            </ul>
                            <div
                              className="tab-content"
                              id="patteren_pinContent"
                            >
                              <div
                                className="tab-pane fade active show"
                                id="pattern"
                                role="tabpanel"
                                aria-labelledby="pattern-tab"
                              >
                                <div className="pattern_field">
                                  <div className="pattern-container">
                                    <div className="pattern-grid">
                                      {arrows.map((arrow, idx) => (
                                        <div
                                          key={idx}
                                          className={`pattern-node ${
                                            selected.includes(idx)
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={() => handleDotClick(idx)}
                                        >
                                          {arrow}
                                        </div>
                                      ))}
                                      <svg className="pattern-lines">
                                        {selected.map((point, i) => {
                                          if (i === 0) return null;
                                          const from = selected[i - 1];
                                          const to = selected[i];
                                          const [x1, y1] = getCoord(from);
                                          const [x2, y2] = getCoord(to);
                                          return (
                                            <line
                                              key={`${from}-${to}`}
                                              x1={x1}
                                              y1={y1}
                                              x2={x2}
                                              y2={y2}
                                              stroke={
                                                i === 1 ? "green" : "green"
                                              }
                                              strokeWidth="4"
                                            />
                                          );
                                        })}
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="pattern_action">
                                    <div
                                      className="refresh_pattern"
                                      onClick={handleReset}
                                    >
                                      <a href="#">
                                        <img
                                          src="assets/img/repair-refresh-icon.png"
                                          alt=""
                                        />
                                      </a>
                                    </div>
                                    <div
                                      className="pattern_save"
                                      onClick={handleSave}
                                    >
                                      <button type="button">Save</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="pin"
                                role="tabpanel"
                                aria-labelledby="pin-tab"
                              >
                                <div className="form_column col_full">
                                  <div className="form-group">
                                    <div className="formfield selectcustomerboxcustmlist">
                                      <input
                                        type={
                                          showPassword ? "text" : "password"
                                        }
                                        className="customsearchinputboxsetting inputdeviceformcustmbox form-control"
                                        placeholder="**************"
                                        autoComplete="new-password"
                                        value={password}
                                        onChange={(e) =>
                                          setPassword(e.target.value)
                                        }
                                      />
                                      <div className="field_icon">
                                        <img
                                          src="assets/img/repair-lock-icon.png"
                                          alt=""
                                        />
                                      </div>
                                      <div className="pin_hide_show">
                                        <a
                                          href="#"
                                          onClick={togglePasswordVisibility}
                                        >
                                          <i
                                            className={`fa ${
                                              showPassword
                                                ? "fa-eye-slash"
                                                : "fa-eye"
                                            }`}
                                          />
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form_column col_full">
                            <div className="form-group">
                              <label className="cus_label">
                                Diagnostic Note
                              </label>
                              <div className="formfield selectcustomerboxcustmlist">
                                <textarea
                                  className="customsearchinputboxsetting inputdeviceformcustmbox form-control"
                                  placeholder="Diagnostic Note"
                                  value={description}
                                  onChange={(e) =>
                                    setDescription(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="pre_repair_btns">
                        <button
                          type="button"
                          className="prerepair_checklist_popup"
                          data-toggle="modal"
                          data-target="#prerepairchecklistModal"
                          onClick={(e) => {
                            e.preventDefault(); // prevent default navigation
                            setShowModal2(true);
                          }}
                        >
                          <img
                            src="assets/img/pre-repair-checklist-icon.png"
                            alt=""
                          />{" "}
                          Pre-Repair Condition Checklist
                        </button>
                        <button
                          type="button"
                          onClick={() => fileInputRef.current.click()}
                        >
                          <img
                            src="assets/img/pre-repair-image-icon.png"
                            alt=""
                          />{" "}
                          Pre-Repair Images
                        </button>

                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          style={{ display: "none" }}
                          ref={fileInputRef}
                          onChange={handlePreRepairImageUpload}
                        />
                      </div>
                      <div className="next_btn">
                        <button
                          type="button"
                          className="btn btn-success theme_btn"
                          onClick={(e) => {
                            handleNext();
                            e.preventDefault();
                            if (!selectedCustomer) {
                              setError((prevError) => ({
                                ...prevError,
                                selectedCustomer:
                                  "Please select a customer before proceeding.",
                              }));
                              return;
                            } // prevent default navigation
                            setError((prevError) => ({
                              ...prevError,
                              selectedCustomer: "",
                            }));
                            // props?.onpress()
                            setShowModal1(true);
                          }}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {showModal2 && (
            <>
              <div
                className="modal show d-block common_modal prerepairchecklist_modal cus_repair_modal"
                id="prerepairchecklistModal"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="prerepairchecklistModalLabel"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered cusmodal_xl"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5
                        className="modal-title"
                        id="prerepairchecklistModalLabel"
                      >
                        Pre-Repair Condition Checklist
                      </h5>
                      <button
                        type="button"
                        className="close"
                        // data-dismiss="modal"
                        // aria-label="Close"
                        onClick={() => setShowModal2(false)}
                      >
                        <span className="close_icon" />
                      </button>
                      <p>
                        Thoroughly inspect and document the device's current
                        condition to identify any pre-existing issues before
                        beginning the repair process.
                      </p>
                    </div>
                    <div className="modal-body">
                      <div className="custom_form repairchecklist_form">
                        <form
                          action=""
                          method=""
                          className="cus_form"
                          data-gtm-form-interact-id={0}
                        >
                          <div className="row">
                            <div className="col-md-12">
                              <div className="checklist_status">
                                <div className="checklist_row select_all">
                                  <div className="checklist_column switch_red">
                                    <div className="switch_field">
                                      <DemoToggle
                                        value={selectAllState}
                                        onChange={handleSelectAllChange}
                                      />
                                      <span className="switch_label">
                                        Select All
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="checklist_row">
                                  {[0, 1, 2].map((colIndex) => (
                                    <div
                                      key={colIndex}
                                      className="checklist_column switch_green"
                                    >
                                      {checklistLabels
                                        .slice(colIndex * 6, (colIndex + 1) * 6)
                                        .map((label, i) => {
                                          const index = colIndex * 6 + i;
                                          const key = checklistKeys[index];

                                          return (
                                            <div
                                              key={key}
                                              className="switch_field"
                                            >
                                              <DemoToggle
                                                value={checklistStates[key]}
                                                onChange={(newState) =>
                                                  handleToggleChange(
                                                    key,
                                                    newState
                                                  )
                                                }
                                              />
                                              <span className="switch_label">
                                                {label}
                                              </span>
                                            </div>
                                          );
                                        })}
                                    </div>
                                  ))}
                                </div>
                              </div>
                              <div className="checklist_addtional_item">
                                <h4>Additional Information</h4>
                                <div className="checklist_checkbox">
                                  {checklistOptions.map((item, index) => (
                                    <div
                                      className="checkbox_column"
                                      key={index}
                                    >
                                      <div className="checkbox">
                                        <label>
                                          <input
                                            type="checkbox"
                                            name="checklist_additional"
                                            checked={selectedItems.includes(
                                              item
                                            )}
                                            onChange={() =>
                                              handleCheckboxChange2(item)
                                            }
                                          />
                                          {item}
                                        </label>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary cancel_btn"
                          // data-dismiss="modal"
                          onClick={() => setShowModal2(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary success_btn"
                          onClick={handleSave2}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          {showModal1 && (
            <>
              <div
                class="modal show d-block common_modal selectdevice_modal cus_repair_modal"
                id="selectdeviceModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="selectdeviceModalLabel"
                aria-hidden="true"
              >
                <NewRepair
                  cretae={props?.onpress}
                  onPress={onpress}
                  customer={selectedCustomerId}
                  date={dueDate}
                  binid={selectedServiceId}
                  repairid={selectedRepairId}
                  warrantyid={selectedWarrantyId}
                  imei={imeiNumber}
                  driver={driverLiecense}
                  password={password}
                  note={description}
                  imageurl={images}
                  checklist={CheckListValues}
                  additional={checkboxOption}
                  status={props?.status}
                  patteren={patteren}
                  assigned={selectedAssigned || props?.profile}
                  onBack={handleBack}
                  onClose={handleCloseAll}
                />
              </div>
            </>
          )}
        </>
      )}
      {showModal && step === 3 && (
        <div
          className="modal fade common_modal addcustomer_modal"
          id="addcustomerModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="addcustomerModalLabel"
          aria-hidden="true"
        >
          <AddCustomerModel
            onCustomerAdd={onPress}
            prop={onLoad}
            onBack={handleBack}
            onClose={handleCloseAll}
          />
        </div>
      )}
    </>
  );
};
function getCoord(index) {
  const row = Math.floor(index / 3);
  const col = index % 3;
  const dotSize = 35;
  const gap = 15;
  const padding = 10;

  const x = padding + col * (dotSize + gap) + dotSize / 2;
  const y = padding + row * (dotSize + gap) + dotSize / 2;

  return [x, y];
}

// function getCoord(index) {
//   const row = Math.floor(index / 3);
//   const col = index % 3;
//   return [col * 35 + 20, row * 35 + 30];
// }
export default CreateTicket;
